/* eslint-disable @angular-eslint/component-class-suffix */
import { Component, Input, OnInit } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { ThemeService } from 'src/app/services/client/theme/theme.service';

@Component({
  selector: 'app-homie-booking-failed-modal',
  templateUrl: './homie-booking-failed-modal.component.html',
  styleUrls: ['./homie-booking-failed-modal.component.scss'],
})
export class HomieBookingFailedModal implements OnInit {
  @Input() bookingReferenceId: any;
  @Input() hotelDetails;
  @Input() type;
  @Input() title: string;
  @Input() message: string;
  @Input() showYesBtn: boolean = true;
  @Input() showNoBtn: boolean = true;
  @Input() yesButtonText: string = 'Try again';
  @Input() noButtonText: string = '';
  @Input() returnPositve: any;
  @Input() returnNegative: any;
  constructor(
    private modalController: ModalController,
    private navController: NavController,
    private theme: ThemeService
  ) {}

  ngOnInit() {}
  closeModal() {
    this.modalController.dismiss();
  }

  help() {
    if (this.theme?.getClientName === 'homie') {
      this.closeModal();
      this.navController.navigateForward([`/customer-support/${this.bookingReferenceId}`]);
    }
  }

  handlePostiveResponse() {
    this.modalController.dismiss(this.returnPositve || {});
  }

  handleNegativeResponse() {
    this.modalController.dismiss(this.returnNegative || {});
  }

}
